export const exportCsv = (array: any, columns: string[]) => {
  const newArray = [];

  for (let i = 0; i < array.length; i++) {
    const newObj: any = {};
    for (let i2 = 0; i2 < columns.length; i2++) {
      newObj[columns[i2]] = array[i][columns[i2]]
        ? array[i][columns[i2]]
        : 'n/a';
    }
    newArray.push(newObj);
  }
  newArray.unshift(columns);

  let str = '';

  for (let i = 0; i < newArray.length; i++) {
    let line = '';
    for (const index in newArray[i]) {
      if (line !== '') line += ',';

      line += newArray[i][index];
    }

    str += line + '\r\n';
  }

  if (!str.match(/^data:text\/csv/i)) {
    str = 'data:text/csv;charset=utf-8,' + str;
  }
  str = encodeURI(str);
  window.open(str, '_blank');
  return str;
};
